<template>
	<div class="container">
		<ol class="breadcrumb category-breadcrumb">
		    <li v-if="render_category.parents">
				<a v-link="{ path: render_route }">{{ render_category.parents.name }}</a>
		    </li>
		    <li>
		    	<a v-link="{ path: render_subroute }">{{ render_category.name }}</a>
		    </li>
			<li class="active">
				<a>{{ render_product.name }}</a>
			</li>
		</ol>
	</div>
</template>

<script>
export default {
	data () {
		return  {
			route: null,
			subroute: null
		}
	},

	vuex: {
		getters: {
			current_product: state => state.current_product
		}
	},

	computed: {
		render_product () {
			return this.current_product
		},

		render_route () {
			return this.route;
		},

		render_subroute () {
			return this.subroute;
		},

		render_category () {
			let id = 0;
			let category = this.current_product.category;
      let subcategory = null;

			if (category) {
				if (category.parents) {
					id = category.parents.id;
					subcategory = category.id;
				} else {
					id = category.id;
				}
			}

			if (id) {
				switch (id) {
					case 1:
						this.route = '/almacenamiento?page=1';
						break;
					case 6:
						this.route = '/sillas?page=1';
						break;
					case 12:
						this.route = '/mesas?page=1';
						break;
					case 19:
						this.route = '/salas?page=1';
						break;
					case 26:
						this.route = '/lamparas?page=1';
						break;
					case 30:
						this.route = '/accesorios?page=1';
						break;
				}
			}

			// if has subcategory set to the route.
			if (subcategory) {
				this.subroute = this.route + '&filter=' + subcategory;
			} else {
				this.subroute = this.route;
			}

			if (this.current_product.category) {
				return this.current_product.category
			}

			return {}
		}
	}
}
</script>

<style scoped>
.breadcrumb {
	text-align: left;
	font-size: 9px;
}
.breadcrumb > li + li:before {
    content: '>';
    color: black;
}
.breadcrumb li {
	padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// Breadcrumb-product.vue?978fa7c6